import {
  TaxonomyBadge,
  TaxonomyForumCategory,
  TaxonomyMilestone,
} from '../implementations';

const mappers = {
  forums: TaxonomyForumCategory,
  milestones: TaxonomyMilestone,
  badges: TaxonomyBadge,
};

export default mappers;
